<template>
  <div class="main-layout">
    <nav class="main-nav">
      <div class="nav-content">
        <router-link to="/home" class="nav-brand">
          <img src="../assets/logo.svg" alt="Varena Logo" class="logo" />
        </router-link>

        <div class="nav-right">
          <LanguageSelector />
          <div class="user-section">
          <template v-if="authStore.isLoggedIn">
            <el-dropdown>
              <span class="user-dropdown">
                {{ authStore.username }}
                <el-icon class="el-icon--right"><arrow-down /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="authStore.logout">Logout</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
          <template v-else>
            <el-button type="primary" @click="authStore.login">Login</el-button>
          </template>
          </div>
        </div>
      </div>
    </nav>

    <Breadcrumb />

    <main class="main-content">
      <router-view></router-view>
    </main>

    <footer class="footer">
      <div class="footer-content">
        <p>{{ t('footer.copyright', { year: currentYear }) }}</p>
        <p>Current Path: {{ route.path }} - Current Name: {{ route.name }} - Public: {{ route.meta.public }} - Requires Auth: {{ route.meta.requiresAuth }}</p>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../stores/auth'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ArrowDown } from '@element-plus/icons-vue'
import Breadcrumb from './Breadcrumb.vue'
import LanguageSelector from './LanguageSelector.vue'

const { t } = useI18n()
const authStore = useAuthStore()
const currentYear = computed(() => new Date().getFullYear())
const route = useRoute()
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 0;
}

.main-nav {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-brand {
  flex-shrink: 0;
  display: flex;
  text-decoration: none;
  color: inherit;
}

.logo {
  height: 40px;
}

.nav-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.user-section {
  flex-shrink: 0;
}

.user-dropdown {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.main-content {
  flex: 1;
  padding: 2rem;
  background-color: #f5f7fa;
  min-height: calc(100vh - 180px);
}

.footer {
  background-color: white;
  border-top: 1px solid #e4e7ed;
  padding: 1.5rem 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
  color: #909399;
}

.el-dropdown-menu {
  min-width: 150px;
}

.el-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .nav-content {
    flex-wrap: wrap;
  }

  .main-content {
    padding: 1rem;
  }
}
</style>

<style>
@import 'element-plus/theme-chalk/el-button.css';
@import 'sweetalert2/dist/sweetalert2.min.css';
</style>
